import React from 'react';

const Features = () => {
  return (
    <section className="ens-domain-container">
      {/* Gold Card Container - Consistent with all components */}
      <div style={{
        background: 'var(--black)',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 0 20px var(--gold)',
        maxWidth: '1000px',
        margin: '20px auto',
      }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ color: 'var(--gold)', fontSize: '32px', fontWeight: 'bold', marginBottom: '10px' }}>
            BankSystem: Your Complete Web3 Financial Ecosystem
          </h1>
          <p style={{ color: 'var(--gold)', fontSize: '16px', marginBottom: '20px' }}>
            Secure Digital Identity, Advanced Wallet Technology & Transparent Financial Innovation
          </p>
        </div>

        {/* Value Proposition */}
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '20px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '2px solid #00ff88'
        }}>
          <h2 style={{ color: '#00ff88', marginBottom: '15px', textAlign: 'center' }}>
            🚀 A New Standard in Financial Services
          </h2>
          <div style={{ color: 'var(--text-light)', lineHeight: '1.6', textAlign: 'center' }}>
            <p style={{ marginBottom: '15px', fontSize: '18px' }}>
              <strong>Your <code style={{ color: '#00ff88', background: 'rgba(0,255,136,0.1)', padding: '2px 6px', borderRadius: '3px' }}>.xbsys.eth</code> domain represents more than access—it's your stake in a fairer financial future.</strong>
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px', marginTop: '20px' }}>
              <div style={{ background: 'rgba(0,255,136,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #00ff88' }}>
                <h4 style={{ color: '#00ff88', margin: '0 0 10px 0' }}>🔑 Universal Access</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Single identity for Payments, Forex, Brokerage, Markets, and all BankSystem services
                </p>
              </div>
              <div style={{ background: 'var(--gold-shadow)', padding: '15px', borderRadius: '5px', border: '1px solid var(--gold)' }}>
                <h4 style={{ color: 'var(--gold)', margin: '0 0 10px 0' }}>💎 Transparent Equity</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Exclusive access to Dbank coin - tokenized shares with real dividend distribution
                </p>
              </div>
              <div style={{ background: 'rgba(0,100,255,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #0064ff' }}>
                <h4 style={{ color: '#0064ff', margin: '0 0 10px 0' }}>🏦 BankSystem Wallet</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Enterprise-grade secure wallet with local creation & multi-chain support
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ENHANCED: BankSystem Wallet Section */}
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '20px',
          borderRadius: '5px',
          marginBottom: '20px',
        }}>
          <h3 style={{ color: 'var(--gold)', marginBottom: '15px', borderBottom: '1px solid var(--gold)', paddingBottom: '10px' }}>
            🏦 BankSystem Wallet - Enterprise-Grade Security
          </h3>
          <div style={{ color: 'var(--text-light)', lineHeight: '1.6' }}>
            <p style={{ marginBottom: '15px' }}>
              Experience the future of self-custody with our enterprise-grade secure wallet technology:
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginBottom: '20px' }}>
              <div style={{ background: 'rgba(0,255,136,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #00ff88' }}>
                <h4 style={{ color: '#00ff88', margin: '0 0 10px 0', fontSize: '16px' }}>🔐 Enterprise-Grade Encryption</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  PBKDF2 + AES-256 encryption with unique keys per user
                </p>
              </div>
              <div style={{ background: 'var(--gold-shadow)', padding: '15px', borderRadius: '5px', border: '1px solid var(--gold)' }}>
                <h4 style={{ color: 'var(--gold)', margin: '0 0 10px 0', fontSize: '16px' }}>🏗️ Local Wallet Creation</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Create wallets directly in-app - complete self-sovereign solution
                </p>
              </div>
              <div style={{ background: 'rgba(0,100,255,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #0064ff' }}>
                <h4 style={{ color: '#0064ff', margin: '0 0 10px 0', fontSize: '16px' }}>🔄 Multi-Wallet Management</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Manage multiple wallets with seamless switching
                </p>
              </div>
              <div style={{ background: 'rgba(255,140,0,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #ff8c00' }}>
                <h4 style={{ color: '#ff8c00', margin: '0 0 10px 0', fontSize: '16px' }}>📊 Portfolio Tracking</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Real-time balances, token prices, and transaction history
                </p>
              </div>
            </div>

            {/* Wallet Security Features */}
            <div style={{ background: 'rgba(0,255,136,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #00ff88', marginBottom: '15px' }}>
              <h4 style={{ color: '#00ff88', margin: '0 0 10px 0', fontSize: '16px' }}>Advanced Security Features</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
                <div>
                  <strong style={{ color: '#00ff88', fontSize: '12px' }}>Password-Derived Keys</strong>
                  <p style={{ fontSize: '11px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Unique encryption per user</p>
                </div>
                <div>
                  <strong style={{ color: '#00ff88', fontSize: '12px' }}>Auto Session Expiry</strong>
                  <p style={{ fontSize: '11px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>30-minute security timeout</p>
                </div>
                <div>
                  <strong style={{ color: '#00ff88', fontSize: '12px' }}>Brute-Force Protection</strong>
                  <p style={{ fontSize: '11px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>100,000 PBKDF2 iterations</p>
                </div>
                <div>
                  <strong style={{ color: '#00ff88', fontSize: '12px' }}>Encrypted Storage</strong>
                  <p style={{ fontSize: '11px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>AES-256 local encryption</p>
                </div>
              </div>
            </div>

            {/* ENHANCED: BankSystem Exclusive Connection Options */}
            <div style={{ background: 'var(--gold-shadow)', padding: '15px', borderRadius: '5px', border: '1px solid var(--gold)' }}>
              <h4 style={{ color: 'var(--gold)', margin: '0 0 10px 0', fontSize: '16px' }}>BankSystem Exclusive Wallet Solutions</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ background: 'rgba(0,255,136,0.2)', padding: '8px', borderRadius: '8px', marginBottom: '5px' }}>
                    <span style={{ fontSize: '20px' }}>🏦</span>
                  </div>
                  <strong style={{ color: '#00ff88', fontSize: '12px' }}>BankSystem Wallet</strong>
                  <p style={{ fontSize: '10px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>Local Creation</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ background: 'rgba(0,100,255,0.2)', padding: '8px', borderRadius: '8px', marginBottom: '5px' }}>
                    <span style={{ fontSize: '20px' }}>🔐</span>
                  </div>
                  <strong style={{ color: '#0064ff', fontSize: '12px' }}>Secure Import</strong>
                  <p style={{ fontSize: '10px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>Private Key</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ background: 'var(--gold-shadow)', padding: '8px', borderRadius: '8px', marginBottom: '5px' }}>
                    <span style={{ fontSize: '20px' }}>📄</span>
                  </div>
                  <strong style={{ color: 'var(--gold)', fontSize: '12px' }}>Seed Phrase</strong>
                  <p style={{ fontSize: '10px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>Recovery Import</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ background: 'rgba(255,140,0,0.2)', padding: '8px', borderRadius: '8px', marginBottom: '5px' }}>
                    <span style={{ fontSize: '20px' }}>🏢</span>
                  </div>
                  <strong style={{ color: '#ff8c00', fontSize: '12px' }}>Enterprise</strong>
                  <p style={{ fontSize: '10px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>Business Accounts</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Custom Infrastructure Advantage */}
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '20px',
          borderRadius: '5px',
          marginBottom: '20px',
        }}>
          <h3 style={{ color: 'var(--gold)', marginBottom: '15px', borderBottom: '1px solid var(--gold)', paddingBottom: '10px' }}>
            🏗️ BankSystem ENS Identity System
          </h3>
          <div style={{ color: 'var(--text-light)', lineHeight: '1.6' }}>
            <p style={{ marginBottom: '15px' }}>
              BankSystem operates its <strong>own ENS minting contract and identity management system</strong>, providing unparalleled security and integration:
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
              <div style={{ background: 'var(--gold-shadow)', padding: '12px', borderRadius: '5px' }}>
                <strong style={{ color: 'var(--gold)' }}>Seamless Experience</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Direct minting within BankSystem ecosystem</p>
              </div>
              <div style={{ background: 'var(--gold-shadow)', padding: '12px', borderRadius: '5px' }}>
                <strong style={{ color: 'var(--gold)' }}>Enhanced Security</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Custom contract logic for financial operations</p>
              </div>
              <div style={{ background: 'var(--gold-shadow)', padding: '12px', borderRadius: '5px' }}>
                <strong style={{ color: 'var(--gold)' }}>Fair Distribution</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Max 5 domains per wallet to prevent hoarding</p>
              </div>
              <div style={{ background: 'var(--gold-shadow)', padding: '12px', borderRadius: '5px' }}>
                <strong style={{ color: 'var(--gold)' }}>Complete Control</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Full ENS management within BankSystem Identity App</p>
              </div>
            </div>
          </div>
        </div>

        {/* Complete Financial Ecosystem */}
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '20px',
          borderRadius: '5px',
          marginBottom: '20px',
        }}>
          <h3 style={{ color: 'var(--gold)', marginBottom: '15px', borderBottom: '1px solid var(--gold)', paddingBottom: '10px' }}>
            🌐 Comprehensive Financial Services
          </h3>
          <div style={{ color: 'var(--text-light)', lineHeight: '1.6' }}>
            <p style={{ marginBottom: '15px' }}>
              BankSystem delivers a complete suite of financial services through owned Web3 infrastructure:
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '15px' }}>
              {[
                { name: 'Web3Pay', desc: 'Payments Infrastructure', status: 'Live' },
                { name: 'Web3Cash', desc: 'Cash Management', status: 'Live' },
                { name: 'Web3FX', desc: 'Forex Trading', status: 'Live' },
                { name: 'Web3Broker', desc: 'Stock Brokerage + AI', status: 'Live' },
                { name: 'Web3Markets', desc: 'RWA Marketplace', status: 'Live' },
                { name: 'BankSystem Wallet', desc: 'Enterprise Web3 Wallet', status: 'Live' },
                { name: 'BankSystem Identity', desc: 'ENS Domain Management', status: 'Live' },
                { name: 'MoneyTalks', desc: 'Financial Community', status: 'Live' }
              ].map((service, index) => (
                <div key={index} style={{
                  background: service.status === 'Live' ? 'rgba(0,255,136,0.1)' : 'var(--gold-shadow)',
                  border: service.status === 'Live' ? '1px solid #00ff88' : '1px solid var(--gold)',
                  padding: '12px',
                  borderRadius: '5px',
                  textAlign: 'center'
                }}>
                  <strong style={{ color: service.status === 'Live' ? '#00ff88' : 'var(--gold)' }}>{service.name}</strong>
                  <p style={{ fontSize: '11px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>{service.desc}</p>
                  <span style={{
                    fontSize: '10px',
                    background: service.status === 'Live' ? '#00ff88' : 'var(--gold)',
                    color: 'var(--black)',
                    padding: '2px 6px',
                    borderRadius: '10px',
                    marginTop: '5px',
                    display: 'inline-block'
                  }}>
                    {service.status}
                  </span>
                </div>
              ))}
            </div>

            {/* Enhanced AI Integration Section */}
            <div style={{ background: 'rgba(0,100,255,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #0064ff', marginTop: '15px' }}>
              <h4 style={{ color: '#0064ff', margin: '0 0 10px 0', fontSize: '16px' }}>🤖 Advanced AI Integration - Meet Grok</h4>
              <p style={{ fontSize: '14px', margin: '0 0 10px 0', color: 'var(--text-secondary)' }}>
                <strong>Grok AI Assistant</strong> provides intelligent support across all BankSystem services:
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', marginTop: '10px' }}>
                <div>
                  <strong style={{ color: '#0064ff', fontSize: '12px' }}>📈 Trading Insights</strong>
                  <p style={{ fontSize: '11px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>Market analysis & strategy suggestions</p>
                </div>
                <div>
                  <strong style={{ color: '#0064ff', fontSize: '12px' }}>💼 Portfolio Advice</strong>
                  <p style={{ fontSize: '11px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>Personalized investment guidance</p>
                </div>
                <div>
                  <strong style={{ color: '#0064ff', fontSize: '12px' }}>🔧 Technical Support</strong>
                  <p style={{ fontSize: '11px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>24/7 assistance for all services</p>
                </div>
                <div>
                  <strong style={{ color: '#0064ff', fontSize: '12px' }}>🎓 Financial Education</strong>
                  <p style={{ fontSize: '11px', margin: '2px 0 0 0', color: 'var(--text-secondary)' }}>Learn complex concepts easily</p>
                </div>
              </div>
            </div>

            {/* Community Focus */}
            <div style={{ background: 'rgba(0,255,136,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #00ff88', marginTop: '15px' }}>
              <h4 style={{ color: '#00ff88', margin: '0 0 10px 0', fontSize: '16px' }}>💬 Community Voice - MoneyTalks Forums</h4>
              <p style={{ fontSize: '14px', margin: '0 0 10px 0', color: 'var(--text-secondary)' }}>
                Powered by Drupal integration, giving every customer a voice. Share insights, discuss strategies,
                and build knowledge together in our transparent financial community.
              </p>
            </div>
          </div>
        </div>

        {/* Enhanced Security Infrastructure */}
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '20px',
          borderRadius: '5px',
          marginBottom: '20px',
        }}>
          <h3 style={{ color: 'var(--gold)', marginBottom: '15px', borderBottom: '1px solid var(--gold)', paddingBottom: '10px' }}>
            🔐 Advanced Security Architecture
          </h3>
          <div style={{ color: 'var(--text-light)', lineHeight: '1.6' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
              <div style={{ background: 'rgba(0,255,136,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #00ff88' }}>
                <h4 style={{ color: '#00ff88', margin: '0 0 10px 0', fontSize: '16px' }}>BankSystem Identity</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Complete ENS domain management with secure minting and primary name setup
                </p>
              </div>
              <div style={{ background: 'var(--gold-shadow)', padding: '15px', borderRadius: '5px', border: '1px solid var(--gold)' }}>
                <h4 style={{ color: 'var(--gold)', margin: '0 0 10px 0', fontSize: '16px' }}>BankSystem Wallet Security</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Enterprise-grade encryption, local wallet creation, and secure key management
                </p>
              </div>
              <div style={{ background: 'rgba(0,100,255,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #0064ff' }}>
                <h4 style={{ color: '#0064ff', margin: '0 0 10px 0', fontSize: '16px' }}>Custom ENS Contracts</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  BankSystem-owned smart contracts for secure domain minting and management
                </p>
              </div>
              <div style={{ background: 'rgba(255,140,0,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #ff8c00' }}>
                <h4 style={{ color: '#ff8c00', margin: '0 0 10px 0', fontSize: '16px' }}>AI Security Monitoring</h4>
                <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>
                  Grok AI provides real-time security alerts and threat detection
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Investment Opportunity */}
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '20px',
          borderRadius: '5px',
          marginBottom: '20px',
        }}>
          <h3 style={{ color: 'var(--gold)', marginBottom: '15px', borderBottom: '1px solid var(--gold)', paddingBottom: '10px' }}>
            📈 Transparent Equity Structure
          </h3>
          <div style={{ color: 'var(--text-light)', lineHeight: '1.6' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap' }}>
              <div style={{ textAlign: 'center', flex: '1', minWidth: '150px', margin: '10px' }}>
                <div style={{ background: 'rgba(0,255,136,0.2)', padding: '10px', borderRadius: '50%', width: '60px', height: '60px', margin: '0 auto 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ color: '#00ff88', fontSize: '24px' }}>1B</span>
                </div>
                <strong style={{ color: '#00ff88' }}>Total Shares</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Professional cap table structure</p>
              </div>
              <div style={{ textAlign: 'center', flex: '1', minWidth: '150px', margin: '10px' }}>
                <div style={{ background: 'var(--gold-shadow)', padding: '10px', borderRadius: '50%', width: '60px', height: '60px', margin: '0 auto 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ color: 'var(--gold)', fontSize: '24px' }}>100M</span>
                </div>
                <strong style={{ color: 'var(--gold)' }}>Public Offering</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Available for investment</p>
              </div>
              <div style={{ textAlign: 'center', flex: '1', minWidth: '150px', margin: '10px' }}>
                <div style={{ background: 'rgba(0,100,255,0.2)', padding: '10px', borderRadius: '50%', width: '60px', height: '60px', margin: '0 auto 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ color: '#0064ff', fontSize: '24px' }}>✓</span>
                </div>
                <strong style={{ color: '#0064ff' }}>Dividends</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Real revenue sharing</p>
              </div>
              <div style={{ textAlign: 'center', flex: '1', minWidth: '150px', margin: '10px' }}>
                <div style={{ background: 'rgba(255,140,0,0.2)', padding: '10px', borderRadius: '50%', width: '60px', height: '60px', margin: '0 auto 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ color: '#ff8c00', fontSize: '24px' }}>🏦</span>
                </div>
                <strong style={{ color: '#ff8c00' }}>Wallet Users</strong>
                <p style={{ fontSize: '12px', margin: '5px 0 0 0', color: 'var(--text-secondary)' }}>Growing ecosystem</p>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Value Proposition */}
        <div style={{
          background: 'linear-gradient(135deg, var(--gold-shadow), rgba(0,255,136,0.2))',
          border: '2px solid var(--gold)',
          borderRadius: '5px',
          padding: '25px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          <h3 style={{ color: 'var(--gold)', margin: '0 0 15px 0', fontSize: '24px' }}>The BankSystem Difference</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginTop: '20px' }}>
            <div style={{ background: 'var(--gold-shadow)', padding: '15px', borderRadius: '5px', border: '1px solid var(--gold)' }}>
              <h4 style={{ color: 'var(--gold)', margin: '0 0 10px 0' }}>🏷️ Lowest Fees</h4>
              <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>Always the most competitive pricing in the market</p>
            </div>
            <div style={{ background: 'rgba(0,255,136,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #00ff88' }}>
              <h4 style={{ color: '#00ff88', margin: '0 0 10px 0' }}>🌍 Global Access</h4>
              <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>World markets available to everyone, equally</p>
            </div>
            <div style={{ background: 'rgba(0,100,255,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #0064ff' }}>
              <h4 style={{ color: '#0064ff', margin: '0 0 10px 0' }}>💬 Community Voice</h4>
              <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>MoneyTalks forums for open financial discussion</p>
            </div>
            <div style={{ background: 'rgba(255,140,0,0.1)', padding: '15px', borderRadius: '5px', border: '1px solid #ff8c00' }}>
              <h4 style={{ color: '#ff8c00', margin: '0 0 10px 0' }}>🔐 Bank-Grade Security</h4>
              <p style={{ fontSize: '14px', margin: '0', color: 'var(--text-secondary)' }}>Enterprise-grade wallet encryption & protection</p>
            </div>
          </div>
        </div>

        {/* Enhanced Call to Action */}
        <div style={{
          background: 'var(--gold-shadow)',
          border: '1px solid var(--gold)',
          borderRadius: '5px',
          padding: '20px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          <h3 style={{ color: 'var(--gold)', margin: '0 0 15px 0' }}>Ready to Join the Future of Ethical Finance?</h3>
          <p style={{ color: 'var(--text-light)', margin: '0 0 15px 0', lineHeight: '1.6' }}>
            Mint your <code style={{ color: '#00ff88', background: 'rgba(0,255,136,0.1)', padding: '4px 8px', borderRadius: '3px', fontSize: '18px' }}>.xbsys.eth</code> domain today and secure your position in the world's most transparent financial ecosystem.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', marginTop: '15px' }}>
            <div style={{ background: 'rgba(0,255,136,0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #00ff88' }}>
              <p style={{ color: '#00ff88', margin: '0', fontSize: '12px', fontWeight: 'bold' }}>
                🏦 Try BankSystem Wallet
              </p>
              <p style={{ color: 'var(--text-secondary)', margin: '5px 0 0 0', fontSize: '11px' }}>
                Create secure wallets instantly
              </p>
            </div>
            <div style={{ background: 'rgba(255,0,0,0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #ff4444' }}>
              <p style={{ color: '#ff6666', margin: '0', fontSize: '12px', fontWeight: 'bold' }}>
                ⚡ Limited Access
              </p>
              <p style={{ color: 'var(--text-secondary)', margin: '5px 0 0 0', fontSize: '11px' }}>
                5 domains per wallet • Ground floor opportunity
              </p>
            </div>
          </div>
        </div>

        {/* Enhanced Technical Excellence Footer */}
        <div style={{
          backgroundColor: 'var(--card-bg)',
          padding: '15px',
          borderRadius: '5px',
          textAlign: 'center',
        }}>
          <h4 style={{ color: 'var(--gold)', marginBottom: '10px' }}>Enterprise-Grade Web3 Infrastructure</h4>
          <p style={{ color: 'var(--gold)', margin: '5px 0', fontSize: '12px' }}>
            Custom ENS Contracts • Enterprise-Grade Wallet Security • AI Agent Integration • Tokenized Equity
          </p>
          <p style={{ color: 'var(--gold)', margin: '5px 0', fontSize: '12px' }}>
            PBKDF2/AES-256 Encryption • Multi-Wallet Management • Real-time Portfolio Tracking • Global Market Access
          </p>
          <p style={{ color: 'var(--gold)', margin: '5px 0', fontSize: '12px' }}>
            BankSystem Identity App • Complete ENS Management • Independent Web3 Banking Ecosystem
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
